import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { pipGetAccessToken } from "../auth/Pip";
import { pageRoutes } from "../routes/PageRoutes";
import { getBussinessProfileData } from "../redux/actions/authActions";

const PrivateRoute = ({ children }) => {
    const dispatch = useDispatch();
    const isAuth = pipGetAccessToken();

    useEffect(() => {
        if (!isAuth) return;
        // Refresh ke baad tooltipSeen/profile state Redux me load nahi hota,
        // isliye ek baar profile fetch kar do (tooltipSeen bhi yahin se aata hai).
        if (!PrivateRoute.__profileFetched) {
            PrivateRoute.__profileFetched = true;
            dispatch(getBussinessProfileData());
        }
    }, [dispatch, isAuth]);

    return isAuth ? children : <Navigate to={pageRoutes?.login} />;
};

export default PrivateRoute;
